import { addNewSMSAccountPayload } from '../../../interfaces/sms';

import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_twilio',
  );
}

export async function addNewSMSAccount(sessionId: string, accountPayload: addNewSMSAccountPayload) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(`${process.env.REACT_APP_API_PATH}/connections/twilio`, requestOptions);
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_twilio',
  );
}

export async function updateAccountDetails(
  sessionId: string,
  accountId: string,
  countryCodes: { [country: string]: string },
) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio/${accountId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
      method: 'POST',
      body: JSON.stringify({ countryCodes }),
    },
    'failed_to_update_twilio',
  );
}

export async function updateOutboundMessagingEnabled(
  sessionId: string,
  accountId: string,
  outboundMessagingEnabled: boolean,
) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio/${accountId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
      method: 'POST',
      body: JSON.stringify({ outboundMessagingEnabled }),
    },
    'failed_to_update_twilio',
  );
}

export async function updateMenuConfig(sessionId: string, accountId: string, menuConfiguration: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio/${accountId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
      method: 'POST',
      body: JSON.stringify({ menuConfiguration }),
    },
    'menu_config_update_failure',
  );
}
